import React from "react";

const Servicos = (props) => {
  return (
    <div id="services" className="container-fluid text-center">
      <h2>SERVIÇOS</h2>
      <h4>O que oferecemos</h4>
      <br />
      <div className="row ">
        <div className="col-sm-4">
          <span className="fa fa-bolt logo-small" />
          <h4>Ronda tática</h4>
          <p>
            Com aplicativo condomínio virtual para acompanhamento das passagens
            do vigilante
          </p>
          <p>9 horas de rondas</p>
          <p>07 dias por semana</p>
          <p>Sem interrupção por doença, feriados ou problemas técnicos.</p>
        </div>
        <div className="col-sm-4">
          <span className="fa fa-video logo-small" />
          <h4>Monitoramento 24 horas</h4>
          <p>
            Sistemas de alarme monitorado ou por vídeo monitoramento
            colaborativo pelo aplicativo icam.
          </p>
        </div>
        <div className="col-sm-4">
          <span className="fa fa-exchange-alt logo-small" />
          <h4>
            Acompanhamento de entrada e saída da residência e acompanhamento de
            fechamento comercial
          </h4>
          <p>
            Chamados através do aplicativo e telefones de contato da empresa.
          </p>
        </div>
      </div>
      <br />
      <br />
      <div className="row ">
        <div className="col-sm-4">
          <span className="fa fa-exclamation-triangle logo-small" />
          <h4>Alerta de pânico com acionamento da PM</h4>
          <p>
            Chamado efetuado pelo aplicativo condomínio virtual e /ou botão
            pânico de alarme 24 horas.
          </p>
        </div>
        <div className="col-sm-4">
          <span className="fa fa-shield-alt logo-small" />
          <h4>Escolta tática</h4>
          <p>
            Agendamento de escolta para movimentação de valores (Consultar
            serviços)
          </p>
        </div>
        <div className="col-sm-4">
          <span className="fa fa-handshake logo-small" />
          <h4>Descontos em serviços de parceiros </h4>
          <p>Descontos mediante apresentação do aplicativo da empresa</p>
        </div>
      </div>
    </div>
  );
};

export default Servicos;
